import {
  HEADER_INIT,
  ACCESS_DENIED_ACTION,
  HEADER_REQUESTING,
  HEADER_REQUEST_SUCCESS,
  HEADER_REQUEST_ERROR,
  HEADER_SET_ACTIVE_BRANCH_REQUESTING,
  HEADER_SET_ACTIVE_BRANCH_SUCCESS,
  HEADER_SET_ACTIVE_BRANCH_ERROR,
} from './constants'

const initialState = {
  data:{
    user: {},
    notifications: [],
    onlines: [],
  }, // where we'll store widgets
  activeBranchData: {},
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  storeIntervalIds: (id) => { 
    window.IntervalIds = window.IntervalIds || [];
    window.IntervalIds.push(id);
  },
  clearIntervalIds: (id) => { 
    window.IntervalIds = window.IntervalIds || [];
    window.IntervalIds.map((item) => {
      window.clearInterval(item);
    });
  },
  type: HEADER_INIT
}

const reducer = function headerReducer (state = initialState, action) {
  switch (action.type) {
    case HEADER_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        requesting: true,
        successful: false,
        messages: [],
        errors: [],
        type: action.type,
      }

    case HEADER_REQUEST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        data: action.headers, // replace with fresh list
        requesting: false,
        successful: true,
        type: action.type,
      }

    case HEADER_REQUEST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        requesting: false,
        successful: false,
        type: action.type,
      }
      
    case HEADER_SET_ACTIVE_BRANCH_REQUESTING:
    return {
      ...state, // ensure that we don't erase fetched ones
      activeBranchData: {},
      requesting: false,
      successful: true,
      messages: [],
      errors: [],
      type: action.type,
    }

  case HEADER_SET_ACTIVE_BRANCH_SUCCESS:
    return {
      ...state, // ensure that we don't erase fetched ones
      activeBranchData: action.payload, // replace with fresh list
      requesting: false,
      successful: true,
      messages: [],
      type: action.type,
    }

  case HEADER_SET_ACTIVE_BRANCH_ERROR:
    return {
      ...state, // ensure that we don't erase fetched ones
      requesting: false,
      successful: false,
      errors: [{
        body: action.error.toString(),
        time: new Date(),
      }],
      type: action.type,
    }
    
    default:
      if (action.error && action.error.code == 413) {
        return {
          data: {},
          activeBranchData: {},
          requesting: false,
          successful: false,
          messages: [],
          errors: [{
            body: action.error.message,
            time: new Date(),
          }],
          type: ACCESS_DENIED_ACTION,
        }
      }
      else {
        return initialState;
      }
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/components/Header/reducer.js